<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> لیست تنظیمات مسابقات </template>
    <template #titleBtn>
      <BButton variant="success" @click="renderCreateMatchSettingDialog">
        ایجاد تنظیمات جدید
      </BButton>
    </template>
    <CustomTable
      :pageNumber="matchSettingFilters.pageNumber"
      :count="matchSettingFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="matchSettingsList"
      @changePage="changePage"
    >
      <template #questionType> چهار گزینه‌ای </template>
      <template #totalMatchQuestionsCount="data">
        <div class="w-100 d-flex align-items-center justify-content-center">
          <BBadge style="font-weight: normal" variant="primary">
            {{ data.item.totalMatchQuestionsCount }} سوال
          </BBadge>
        </div>
      </template>
      <template #createAt="data">
        {{ customFullDateConvert(data.item.createAt) }}
        -
        {{ customConvertHourAndMinute(data.item.createAt) }}
      </template>
      <template #actions="data">
        <BButton
          size="sm"
          variant="transparent"
          @click="renderUpdateMatchSettingDialog(data.item)"
        >
          <FeatherIcon icon="EditIcon" size="20" class="text-info" />
        </BButton>
      </template>
    </CustomTable>
    <CreateMatchSettingDialog @refetch="getAllMatchSettings">
    </CreateMatchSettingDialog>
    <UpdateMatchSettingDialog
      :defaultMatchSettings="tempSelectedSetting"
      @refetch="getAllMatchSettings"
    ></UpdateMatchSettingDialog>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getAllMatchSettings();
  },
  data() {
    return {
      isLoading: false,
      matchSettingsList: null,
      totalCount: null,
      tempSelectedSetting: null,
      matchSettingFilters: {
        pageNumber: 1,
        count: 10,
        questionType: 1, //For 4 answer questions only
      },
      tableColumns: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "title",
          label: "عنوان تنظیمات",
          formatter: (val) => (val ? val : "-"),
        },
        {
          key: "questionType",
          label: "نوع سوال ها",
        },
        {
          key: "totalMatchQuestionsCount",
          label: "تعداد سوال های مسابقه",
        },
        {
          key: "createAt",
          label: "تاریخ ایجاد",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    changePage(pageNumber) {
      this.matchSettingFilters.pageNumber = pageNumber;
      this.getAllMatchSettings();
    },
    async getAllMatchSettings() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllMatchSettingsReq = new GetAllMatchSettings(_this);
        getAllMatchSettingsReq.setRequestParam(_this.matchSettingFilters);
        await getAllMatchSettingsReq.fetch((res) => {
          _this.matchSettingsList = res.data.data;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    renderCreateMatchSettingDialog() {
      this.$bvModal.show("create-match-setting-dialog");
    },
    renderUpdateMatchSettingDialog(matchSetting) {
      this.tempSelectedSetting = matchSetting;
      this.$bvModal.show("update-match-setting-dialog");
    },
  },
  mixins: [timeConvertUtils],
  components: {
    PageWrapper,
    CreateMatchSettingDialog,
    UpdateMatchSettingDialog,
    CustomTable,
    BButton,
    BBadge,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CreateMatchSettingDialog from "@/views/components/Matches/CreateMatchSettingDialog.vue";
import UpdateMatchSettingDialog from "@/views/components/Matches/UpdateMatchSettingDialog.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import timeConvertUtils from "@/mixins/timeConvertUtils";
import { BButton, BBadge } from "bootstrap-vue";
import { GetAllMatchSettings } from "@/libs/Api/Matches";
</script>
